
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("bvNVx", function(module, exports) {
/**
 * @generated SignedSource<<8eefffb770c376eb82455e0d47b84009>>
 * @relayHash 11ce33df0e31c52950aa35b62b331009
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 69d939c305c08c86e8ab85db73769cddd5f12ba8cc655bb192aadb5737584e8b
const $148495f1c40d94de$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "enabled"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "enabled",
            "variableName": "enabled"
        },
        {
            "kind": "Variable",
            "name": "spaceKey",
            "variableName": "spaceKey"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "success"
    }, v5 = {
        "kind": "ScalarField",
        "name": "isContentApprovalsEnabled"
    }, v6 = {
        "kind": "ScalarField",
        "name": "message"
    }, v7 = {
        "kind": "ScalarField",
        "name": "errorType"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "StatusAndApprovalsConfigSetApprovalsMutation",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "ConfluenceContentApprovalsSpaceSettingsPayload",
                    "kind": "LinkedField",
                    "name": "confluence_setContentApprovalsSpaceSettings",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "StatusAndApprovalsConfigSetApprovalsMutation",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "ConfluenceContentApprovalsSpaceSettingsPayload",
                    "kind": "LinkedField",
                    "name": "confluence_setContentApprovalsSpaceSettings",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "11ce33df0e31c52950aa35b62b331009",
            "id": "69d939c305c08c86e8ab85db73769cddd5f12ba8cc655bb192aadb5737584e8b",
            "metadata": {},
            "name": "StatusAndApprovalsConfigSetApprovalsMutation",
            "operationKind": "mutation",
            "text": "mutation StatusAndApprovalsConfigSetApprovalsMutation($cloudId:ID!,$spaceKey:String!,$enabled:Boolean!){confluence_setContentApprovalsSpaceSettings(cloudId:$cloudId,spaceKey:$spaceKey,enabled:$enabled){success,isContentApprovalsEnabled,errors{message,extensions{__typename,errorType,...on BulkMutationErrorExtension{id}}}}}"
        }
    };
}();
$148495f1c40d94de$var$node.hash = "69f9fa52fe38b61631c5e3e1a7f9e59c";
var $148495f1c40d94de$export$2e2bcd8739ae039 = $148495f1c40d94de$var$node;


/**
 * @generated SignedSource<<2b51403a2b212cb47dc53b8492bc3ec2>>
 * @relayHash ccf377627f575b4d14e9df7c37f6701d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bacdce51376d81c5f867bd8d669c95640de30fc2d03d26b93b4fbf0d39f2c171
const $bedcb5bf89529245$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatesSetting"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "customStatesSetting"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceStatesSetting"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentStatesSetting",
                    "variableName": "contentStatesSetting"
                },
                {
                    "kind": "Variable",
                    "name": "customStatesSetting",
                    "variableName": "customStatesSetting"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "spaceStatesSetting",
                    "variableName": "spaceStatesSetting"
                }
            ],
            "concreteType": "ContentStateSettings",
            "kind": "LinkedField",
            "name": "setContentStateSettings",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "contentStatesAllowed"
                },
                {
                    "kind": "ScalarField",
                    "name": "spaceContentStatesAllowed"
                },
                {
                    "kind": "ScalarField",
                    "name": "customContentStatesAllowed"
                },
                {
                    "concreteType": "ContentState",
                    "kind": "LinkedField",
                    "name": "spaceContentStates",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "color"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "restrictionLevel"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "StatusAndApprovalsConfigSetContentStateSettingsMutation",
            "selections": v4 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "StatusAndApprovalsConfigSetContentStateSettingsMutation",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "ccf377627f575b4d14e9df7c37f6701d",
            "id": "bacdce51376d81c5f867bd8d669c95640de30fc2d03d26b93b4fbf0d39f2c171",
            "metadata": {},
            "name": "StatusAndApprovalsConfigSetContentStateSettingsMutation",
            "operationKind": "mutation",
            "text": "mutation StatusAndApprovalsConfigSetContentStateSettingsMutation($spaceKey:String!,$contentStatesSetting:Boolean!,$customStatesSetting:Boolean!,$spaceStatesSetting:Boolean!){setContentStateSettings(spaceKey:$spaceKey,contentStatesSetting:$contentStatesSetting,customStatesSetting:$customStatesSetting,spaceStatesSetting:$spaceStatesSetting){contentStatesAllowed,spaceContentStatesAllowed,customContentStatesAllowed,spaceContentStates{name,color,id,restrictionLevel}}}"
        }
    };
}();
$bedcb5bf89529245$var$node.hash = "a404c4bfc7b55d577281ff4d9609ab63";
var $bedcb5bf89529245$export$2e2bcd8739ae039 = $bedcb5bf89529245$var$node;


/**
 * @generated SignedSource<<3fc233b23dab865cf6930a38a7020439>>
 * @relayHash 7e21202b926d45e062e09a0c01cc56e5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 80c8cf688c8b87204396177172e6eb577d68c8b3816e93c34f0fd8f4c331478f
const $839166fb71f87431$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "ConfluenceApprovalsWorkflowStatus",
            "kind": "LinkedField",
            "name": "confluence_contentApprovalStatuses",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "allowsReviews"
                },
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ConfluenceApprovalsWorkflowStatusDisplayProperties",
                    "kind": "LinkedField",
                    "name": "displayProperties",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "StatusAndApprovalsConfigApprovalStatusesQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "StatusAndApprovalsConfigApprovalStatusesQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "7e21202b926d45e062e09a0c01cc56e5",
            "id": "80c8cf688c8b87204396177172e6eb577d68c8b3816e93c34f0fd8f4c331478f",
            "metadata": {},
            "name": "StatusAndApprovalsConfigApprovalStatusesQuery",
            "operationKind": "query",
            "text": "query StatusAndApprovalsConfigApprovalStatusesQuery($cloudId:ID!){confluence_contentApprovalStatuses(cloudId:$cloudId){allowsReviews,id,displayProperties{name}}}"
        }
    };
}();
$839166fb71f87431$var$node.hash = "367eaae38c3e2d4ef9d0e2f94f47b108";
var $839166fb71f87431$export$2e2bcd8739ae039 = $839166fb71f87431$var$node;


/**
 * @generated SignedSource<<148a7d8c8d2b3cee50bcbdddae59eb66>>
 * @relayHash 157a52d310a2bb45a947c5682ad3e70e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9db424d7408a3f207ff22d38862a6f452caf7d771e634a17cb58628cbbd23101
const $d2f7abdec0d40fc6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "SpaceSettings",
                    "kind": "LinkedField",
                    "name": "settings",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentStateSettings",
                            "kind": "LinkedField",
                            "name": "contentStateSettings",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "contentStatesAllowed"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "spaceContentStatesAllowed"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "customContentStatesAllowed"
                                },
                                {
                                    "concreteType": "ContentState",
                                    "kind": "LinkedField",
                                    "name": "spaceContentStates",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "color"
                                        },
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "restrictionLevel"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "SpaceTypeSettings",
                    "kind": "LinkedField",
                    "name": "spaceTypeSettings",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "EnabledFeatures",
                            "kind": "LinkedField",
                            "name": "enabledFeatures",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isContentApprovalsEnabled"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "StatusAndApprovalsConfigSettingsQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "StatusAndApprovalsConfigSettingsQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "157a52d310a2bb45a947c5682ad3e70e",
            "id": "9db424d7408a3f207ff22d38862a6f452caf7d771e634a17cb58628cbbd23101",
            "metadata": {},
            "name": "StatusAndApprovalsConfigSettingsQuery",
            "operationKind": "query",
            "text": "query StatusAndApprovalsConfigSettingsQuery($spaceKey:String!){space(key:$spaceKey){id,settings{contentStateSettings{contentStatesAllowed,spaceContentStatesAllowed,customContentStatesAllowed,spaceContentStates{name,color,id,restrictionLevel}}},spaceTypeSettings{enabledFeatures{isContentApprovalsEnabled}}}}"
        }
    };
}();
$d2f7abdec0d40fc6$var$node.hash = "56245d911a1da1b58254ccfa0962d2e7";
var $d2f7abdec0d40fc6$export$2e2bcd8739ae039 = $d2f7abdec0d40fc6$var$node;



var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $hQNhB = parcelRequire("hQNhB");


var $6T8v4 = parcelRequire("6T8v4");


var $9hlns = parcelRequire("9hlns");


var $gdv5Z = parcelRequire("gdv5Z");


var $gITTQ = parcelRequire("gITTQ");


var $bJRX9 = parcelRequire("bJRX9");


var $imt6g = parcelRequire("imt6g");


var $b3j2Y = parcelRequire("b3j2Y");


var $7Sm4c = parcelRequire("7Sm4c");


var $7aRa9 = parcelRequire("7aRa9");


var $jMyy4 = parcelRequire("jMyy4");


var $308Wd = parcelRequire("308Wd");


var $bQm3c = parcelRequire("bQm3c");


var $jmjWc = parcelRequire("jmjWc");


const $3b83ca197b5ddfda$export$fff86a3fe157bf8e = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "w3mlD",
    name: "DisableApprovalsModal",
    loader: async ()=>(await (parcelRequire("1WCRA"))).DisableApprovalsModal
});



var $Uu0Pb = parcelRequire("Uu0Pb");


var $1jGHE = parcelRequire("1jGHE");


var $5tbZ4 = parcelRequire("5tbZ4");


var $8u6FF = parcelRequire("8u6FF");


var $8kr7I = parcelRequire("8kr7I");

const $481b573c7e6b5baf$var$i18n = (0, $aXWIB.defineMessages)({
    disabled: {
        id: "content-state.space-admin.status-and-approvals.mode.disabled",
        defaultMessage: "Disabled"
    },
    statusesOnly: {
        id: "content-state.space-admin.status-and-approvals.mode.statuses-only",
        defaultMessage: "Enable statuses only"
    },
    statusesWithApprovals: {
        id: "content-state.space-admin.status-and-approvals.mode.statuses-with-approvals",
        defaultMessage: "Enable statuses with approvals"
    },
    startApproval: {
        id: "content-state.space-admin.status-and-approvals.start-approval",
        defaultMessage: "Start approval"
    },
    suggestedStatesRequiredForApprovals: {
        id: "content-state.space-admin.status-and-approvals.suggested-states-required",
        defaultMessage: "Suggested statuses are required when approvals are enabled"
    },
    errorFlagTitle: {
        id: "content-state.space-admin.status-and-approvals.error-flag.title",
        defaultMessage: "Something went wrong"
    },
    errorFlagDescription: {
        id: "content-state.space-admin.status-and-approvals.error-flag.description",
        defaultMessage: "Your changes could not be saved. Please try again."
    }
});
const $481b573c7e6b5baf$var$spinnerStyles = {
    root: "_1e0c1txw _1bah1h6o"
};
const $481b573c7e6b5baf$var$selectWrapperStyles = {
    root: "_p12f1ogm"
};
const $481b573c7e6b5baf$var$statusesSectionStyles = {
    root: "_1q51pxbi"
};
const $481b573c7e6b5baf$export$16eeafc73450b798 = '1';
const $481b573c7e6b5baf$export$5dcb757926e5c553 = '2';
const $481b573c7e6b5baf$export$1fa7ec55e4b214fc = '3';
const $481b573c7e6b5baf$var$settingsQuery = (0, $d2f7abdec0d40fc6$export$2e2bcd8739ae039);
const $481b573c7e6b5baf$var$approvalStatusesQuery = (0, $839166fb71f87431$export$2e2bcd8739ae039);
const $481b573c7e6b5baf$var$setContentStateMutation = (0, $bedcb5bf89529245$export$2e2bcd8739ae039);
const $481b573c7e6b5baf$var$setApprovalsMutation = (0, $148495f1c40d94de$export$2e2bcd8739ae039);
const $481b573c7e6b5baf$var$StatusAndApprovalsConfigComponent = ({ spaceKey: spaceKey, flags: flags })=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const showErrorFlag = (error)=>{
        (0, $7Sm4c.markErrorAsHandled)(error);
        flags.showErrorFlag({
            id: 'status-and-approvals-config-error',
            title: formatMessage($481b573c7e6b5baf$var$i18n.errorFlagTitle),
            description: formatMessage($481b573c7e6b5baf$var$i18n.errorFlagDescription)
        });
    };
    const originalSuggestedStatesArray = (0, $42omo.useMemo)(()=>[
            {
                color: (0, $Uu0Pb.PRIMARY_COLORS).YELLOW.toLowerCase(),
                name: formatMessage((0, $1jGHE.i18n).roughDraft),
                id: null
            },
            {
                color: (0, $Uu0Pb.PRIMARY_COLORS).BLUE.toLowerCase(),
                name: formatMessage((0, $1jGHE.i18n).inProgress),
                id: null
            },
            {
                color: (0, $Uu0Pb.PRIMARY_COLORS).GREEN.toLowerCase(),
                name: formatMessage((0, $1jGHE.i18n).readyForReview),
                id: null
            },
            {
                color: '#1d7afc',
                name: formatMessage((0, $1jGHE.i18n).verified),
                id: null,
                restrictionLevel: 'PAGE_OWNER'
            }
        ], [
        formatMessage
    ]);
    const [{ mode: mode, suggestedEnabled: suggestedEnabled, customEnabled: customEnabled, suggestedStatesArray: suggestedStatesArray }, setSettingsState] = (0, $42omo.useState)({
        mode: 'disabled',
        suggestedEnabled: true,
        customEnabled: true,
        suggestedStatesArray: originalSuggestedStatesArray
    }); // Holds the mode the admin is attempting to switch to from `approvals`. While
    // this is non-null the warning modal is open and `handleModeChange` has NOT
    // been called yet — so the underlying Select value (bound to `mode`) still
    // shows `approvals` and can be cancelled with no mutation fired.
    const [pendingMode, setPendingMode] = (0, $42omo.useState)(null);
    const { data: settingsData, loading: settingsLoading, error: settingsError } = (0, $jMyy4.useQueryInterop)($481b573c7e6b5baf$var$settingsQuery, {
        fetchPolicy: 'cache-and-network',
        variables: {
            spaceKey: spaceKey
        },
        __callerPackage__: "@confluence/content-state"
    }); // TODO: add more robust error handling for the approval statuses query (e.g. inline error state)
    const { data: approvalStatusesData } = (0, $jMyy4.useQueryInterop)($481b573c7e6b5baf$var$approvalStatusesQuery, {
        fetchPolicy: 'cache-and-network',
        variables: {
            cloudId: cloudId
        },
        skip: mode !== 'approvals',
        onError: (error_0)=>showErrorFlag(error_0),
        __callerPackage__: "@confluence/content-state"
    });
    const [setContentStateSettings] = (0, $308Wd.useMutationInterop)($481b573c7e6b5baf$var$setContentStateMutation, {
        __callerPackage__: "@confluence/content-state"
    });
    const [setApprovalsSettings] = (0, $308Wd.useMutationInterop)($481b573c7e6b5baf$var$setApprovalsMutation, {
        __callerPackage__: "@confluence/content-state"
    });
    const setSuggestedStatesArray = (newStates)=>setSettingsState((prev)=>({
                ...prev,
                suggestedStatesArray: newStates
            })); // Derive all settings state from query data in a single update
    (0, $42omo.useEffect)(()=>{
        if (settingsData) {
            const contentStateData = settingsData?.space?.settings?.contentStateSettings;
            const contentStatesAllowed = contentStateData?.contentStatesAllowed ?? false;
            const isContentApprovalsEnabled = settingsData?.space?.spaceTypeSettings?.enabledFeatures?.isContentApprovalsEnabled ?? false;
            let newMode;
            if (!contentStatesAllowed) newMode = 'disabled';
            else if (isContentApprovalsEnabled) newMode = 'approvals';
            else newMode = 'statuses';
            const newStates_0 = [
                ...contentStateData?.spaceContentStates ?? originalSuggestedStatesArray
            ].map((s)=>s ?? null);
            setSettingsState({
                mode: newMode,
                suggestedEnabled: contentStateData?.spaceContentStatesAllowed ?? true,
                customEnabled: contentStateData?.customContentStatesAllowed ?? true,
                suggestedStatesArray: newStates_0
            });
        }
    }, [
        settingsData,
        originalSuggestedStatesArray
    ]); // Derive showRestoreDefaults without a separate state to avoid chain updates
    const showRestoreDefaults = (0, $42omo.useMemo)(()=>{
        if (suggestedStatesArray.length !== originalSuggestedStatesArray.length) return true;
        for(let i = 0; i < suggestedStatesArray.length; ++i){
            if (suggestedStatesArray[i]?.color?.toUpperCase() !== originalSuggestedStatesArray[i].color?.toUpperCase() || suggestedStatesArray[i]?.name !== originalSuggestedStatesArray[i].name) return true;
        }
        return false;
    }, [
        suggestedStatesArray,
        originalSuggestedStatesArray
    ]);
    const showErrorFlagForError = (error_1)=>{
        showErrorFlag(error_1 instanceof Error ? error_1 : new Error(String(error_1)));
    }; // TODO: add more robust error handling with state rollback on mutation failure
    const handleModeChange = async (newMode_0)=>{
        setSettingsState((prev_0)=>({
                ...prev_0,
                mode: newMode_0
            }));
        const contentStatesEnabled = newMode_0 !== 'disabled';
        const approvalsEnabled = newMode_0 === 'approvals';
        try {
            await setContentStateSettings({
                variables: {
                    spaceKey: spaceKey,
                    contentStatesSetting: contentStatesEnabled,
                    spaceStatesSetting: contentStatesEnabled ? suggestedEnabled : true,
                    customStatesSetting: contentStatesEnabled ? customEnabled : true
                }
            });
        } catch (error_2) {
            showErrorFlagForError(error_2);
        }
        try {
            await setApprovalsSettings({
                variables: {
                    cloudId: cloudId,
                    spaceKey: spaceKey,
                    enabled: approvalsEnabled
                }
            });
        } catch (error_3) {
            showErrorFlagForError(error_3);
        }
    }; // TODO: add more robust error handling with state rollback on mutation failure
    const onSuggestedToggleChange = ()=>{
        const newSuggestedEnabled = !suggestedEnabled;
        setSettingsState((prev_1)=>({
                ...prev_1,
                suggestedEnabled: newSuggestedEnabled
            }));
        setContentStateSettings({
            variables: {
                spaceKey: spaceKey,
                contentStatesSetting: true,
                spaceStatesSetting: newSuggestedEnabled,
                customStatesSetting: customEnabled
            }
        }).catch(showErrorFlagForError);
    }; // TODO: add more robust error handling with state rollback on mutation failure
    const onCustomToggleChange = ()=>{
        const newCustomEnabled = !customEnabled;
        setSettingsState((prev_2)=>({
                ...prev_2,
                customEnabled: newCustomEnabled
            }));
        setContentStateSettings({
            variables: {
                spaceKey: spaceKey,
                contentStatesSetting: true,
                spaceStatesSetting: suggestedEnabled,
                customStatesSetting: newCustomEnabled
            }
        }).catch(showErrorFlagForError);
    }; // Build additionalRows from workflow statuses for approvals mode
    const workflowAdditionalRows = (0, $42omo.useMemo)(()=>{
        const approvalStatuses = approvalStatusesData?.confluence_contentApprovalStatuses;
        if (!approvalStatuses?.length) // eslint-disable-line confluence-feature-gating/no-preconditioning
        return [];
        const rows = [
            {
                key: 'start-approval',
                insertBeforeRestrictedState: true,
                node: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8kr7I.SuggestedContentState), {
                    spaceKey: spaceKey,
                    color: (0, $Uu0Pb.PRIMARY_COLORS).BLUE,
                    name: formatMessage($481b573c7e6b5baf$var$i18n.startApproval),
                    removeState: (0, (/*@__PURE__*/$parcel$interopDefault($hQNhB))),
                    hideTrash: true,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($gITTQ))),
                    iconColor: "var(--ds-icon-accent-blue, #357DE8)",
                    showBetaTag: true
                })
            }
        ];
        for (const s_0 of approvalStatuses)if (s_0 != null) {
            let icon;
            let iconColor;
            if (s_0.id === $481b573c7e6b5baf$export$1fa7ec55e4b214fc) {
                icon = (0, (/*@__PURE__*/$parcel$interopDefault($bJRX9)));
                iconColor = "var(--ds-icon-accent-blue, #357DE8)";
            } else if (s_0.id === $481b573c7e6b5baf$export$16eeafc73450b798) {
                icon = (0, (/*@__PURE__*/$parcel$interopDefault($gITTQ)));
                iconColor = "var(--ds-icon-accent-blue, #357DE8)";
            } else {
                icon = (0, (/*@__PURE__*/$parcel$interopDefault($imt6g)));
                iconColor = "var(--ds-icon-accent-lime, #6A9A23)";
            }
            rows.push({
                key: s_0.id ?? s_0.displayProperties?.name ?? 'workflow',
                insertBeforeRestrictedState: true,
                node: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8kr7I.SuggestedContentState), {
                    spaceKey: spaceKey,
                    color: (0, $Uu0Pb.PRIMARY_COLORS).BLUE,
                    name: s_0.displayProperties?.name ?? null,
                    removeState: (0, (/*@__PURE__*/$parcel$interopDefault($hQNhB))),
                    hideTrash: true,
                    icon: icon,
                    iconColor: iconColor
                })
            });
        }
        return rows;
    }, [
        approvalStatusesData,
        formatMessage,
        spaceKey
    ]);
    const selectOptions = [
        {
            value: 'disabled',
            label: formatMessage($481b573c7e6b5baf$var$i18n.disabled)
        },
        {
            value: 'statuses',
            label: formatMessage($481b573c7e6b5baf$var$i18n.statusesOnly)
        },
        {
            value: 'approvals',
            label: formatMessage($481b573c7e6b5baf$var$i18n.statusesWithApprovals)
        }
    ];
    const selectedOption = selectOptions.find((o)=>o.value === mode) ?? selectOptions[0];
    if (settingsError) {
        (0, $7Sm4c.markErrorAsHandled)(settingsError);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: settingsError
        });
    }
    if (settingsLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $481b573c7e6b5baf$var$spinnerStyles.root
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $481b573c7e6b5baf$var$selectWrapperStyles.root
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6T8v4.default), {
        inputId: "status-and-approvals-mode-select",
        testId: "status-and-approvals-mode-select",
        options: selectOptions,
        value: selectedOption,
        onChange: (option)=>{
            if (!option) return;
             // When leaving `approvals` mode for `statuses` or `disabled`, defer the
            // mutation until the admin confirms in the warning modal. Cancelling the
            // modal leaves `mode` untouched, so the Select naturally rolls back.
            if (mode === 'approvals' && option.value !== 'approvals') {
                setPendingMode(option.value);
                return;
            }
            handleModeChange(option.value);
        }
    })), pendingMode !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3b83ca197b5ddfda$export$fff86a3fe157bf8e), {
        targetMode: pendingMode,
        onConfirm: ()=>{
            const targetMode = pendingMode;
            setPendingMode(null);
            handleModeChange(targetMode);
        },
        onClose: ()=>setPendingMode(null)
    }), mode === 'statuses' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $481b573c7e6b5baf$var$statusesSectionStyles.root
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5tbZ4.ToggleSection), {
        testId: "suggested-states-toggle",
        spaceKey: spaceKey,
        titleText: formatMessage((0, $1jGHE.i18n).suggestedStateSuggestionsTitle),
        bodyText: formatMessage((0, $1jGHE.i18n).suggestedStateSuggestionsBody),
        isChecked: suggestedEnabled,
        underlinedBodyText: formatMessage((0, $1jGHE.i18n).restoreDefaults),
        originalSuggestedStatesArray: originalSuggestedStatesArray,
        setSuggestedStatesArray: setSuggestedStatesArray,
        onToggleClick: onSuggestedToggleChange,
        showRestoreDefaults: showRestoreDefaults
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8u6FF.SuggestedContentStateCustomizationArea), {
        spaceKey: spaceKey,
        showSuggested: suggestedEnabled,
        suggestedStatesArray: suggestedStatesArray,
        setSuggestedStatesArray: setSuggestedStatesArray
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5tbZ4.ToggleSection), {
        testId: "custom-states-toggle",
        spaceKey: spaceKey,
        titleText: formatMessage((0, $1jGHE.i18n).allowCustomContentStatesTitle),
        bodyText: formatMessage((0, $1jGHE.i18n).allowCustomContentStatesBody),
        isChecked: customEnabled,
        onToggleClick: onCustomToggleChange
    })), mode === 'approvals' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $481b573c7e6b5baf$var$statusesSectionStyles.root
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5tbZ4.ToggleSection), {
        testId: "suggested-states-toggle",
        spaceKey: spaceKey,
        titleText: formatMessage((0, $1jGHE.i18n).suggestedStateSuggestionsTitle),
        bodyText: formatMessage((0, $1jGHE.i18n).suggestedStateSuggestionsBody),
        underlinedBodyText: formatMessage((0, $1jGHE.i18n).restoreDefaults),
        originalSuggestedStatesArray: originalSuggestedStatesArray,
        setSuggestedStatesArray: setSuggestedStatesArray,
        showRestoreDefaults: showRestoreDefaults,
        isChecked: true,
        isToggleDisabled: true,
        disabledTooltip: formatMessage($481b573c7e6b5baf$var$i18n.suggestedStatesRequiredForApprovals),
        onToggleClick: (0, (/*@__PURE__*/$parcel$interopDefault($hQNhB)))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8u6FF.SuggestedContentStateCustomizationArea), {
        spaceKey: spaceKey,
        showSuggested: true,
        suggestedStatesArray: suggestedStatesArray,
        setSuggestedStatesArray: setSuggestedStatesArray,
        additionalRows: workflowAdditionalRows
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5tbZ4.ToggleSection), {
        testId: "custom-states-toggle",
        spaceKey: spaceKey,
        titleText: formatMessage((0, $1jGHE.i18n).allowCustomContentStatesTitle),
        bodyText: formatMessage((0, $1jGHE.i18n).allowCustomContentStatesBody),
        isChecked: customEnabled,
        onToggleClick: onCustomToggleChange
    })));
};
const $481b573c7e6b5baf$export$8628923d443707fa = (0, $7aRa9.withFlags)($481b573c7e6b5baf$var$StatusAndApprovalsConfigComponent);
module.exports["IN_REVIEW_STATUS_ID"] = $481b573c7e6b5baf$export$16eeafc73450b798;
module.exports["APPROVED_STATUS_ID"] = $481b573c7e6b5baf$export$5dcb757926e5c553;
module.exports["CHANGES_REQUESTED_STATUS_ID"] = $481b573c7e6b5baf$export$1fa7ec55e4b214fc;
module.exports["StatusAndApprovalsConfig"] = $481b573c7e6b5baf$export$8628923d443707fa;

});

parcelRegister("hQNhB", function(module, exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $cfed858cac4ecf38$var$noop() {
// No operation performed.
}
module.exports = $cfed858cac4ecf38$var$noop;

});

parcelRegister("gITTQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::177057641801787c460d2f596e29ad78>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c2cc1dea213bb1d6$var$_react = $c2cc1dea213bb1d6$var$_interopRequireDefault((parcelRequire("42omo")));

var $c2cc1dea213bb1d6$var$_baseNew = $c2cc1dea213bb1d6$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $c2cc1dea213bb1d6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusWorkflowInReview".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing statuses that signal consideration, assessment, and review
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c2cc1dea213bb1d6$var$StatusWorkflowInReviewIcon = (props)=>/*#__PURE__*/ $c2cc1dea213bb1d6$var$_react.default.createElement($c2cc1dea213bb1d6$var$_baseNew.default, Object.assign({
        name: "StatusWorkflowInReviewIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M8 3a5 5 0 1 1-5 5h5z"/><path fill="currentcolor" d="M1.5 8A6.5 6.5 0 1 0 8 1.5V0a8 8 0 1 1-8 8z"/><path fill="currentcolor" d="m.812 7.053.743.097A7 7 0 0 0 1.5 8H0q0-.53.067-1.044zm2.03-3.01c-.343.447-.63.94-.849 1.469L.607 4.938a8 8 0 0 1 1.046-1.81zm2.67-2.05a6.5 6.5 0 0 0-1.469.85l-.914-1.19A8 8 0 0 1 4.938.607zM8 1.5q-.433 0-.85.055L7.053.812 6.956.067Q7.47.001 8 0z"/>`
    }, props));
$c2cc1dea213bb1d6$var$StatusWorkflowInReviewIcon.displayName = 'StatusWorkflowInReviewIcon';
var $c2cc1dea213bb1d6$var$_default = module.exports.default = $c2cc1dea213bb1d6$var$StatusWorkflowInReviewIcon;

});

parcelRegister("bJRX9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b08853290efcdd597667e3431b2ad7db>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $88bdbf9dcbbc0177$var$_react = $88bdbf9dcbbc0177$var$_interopRequireDefault((parcelRequire("42omo")));

var $88bdbf9dcbbc0177$var$_baseNew = $88bdbf9dcbbc0177$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $88bdbf9dcbbc0177$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusWorkflowReturned".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing statuses that return to a previous state in the process such as "Redeploy", "Needs more information"
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $88bdbf9dcbbc0177$var$StatusWorkflowReturnedIcon = (props)=>/*#__PURE__*/ $88bdbf9dcbbc0177$var$_react.default.createElement($88bdbf9dcbbc0177$var$_baseNew.default, Object.assign({
        name: "StatusWorkflowReturnedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 8a6.5 6.5 0 1 0-13 0 6.5 6.5 0 0 0 13 0M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0"/><path fill="currentcolor" d="M10.5 8.75A1.75 1.75 0 0 0 8.75 7H7.293l.358.628a.75.75 0 0 1-1.112.964l-2.25-1.75a.75.75 0 0 1 0-1.184l2.25-1.75a.75.75 0 0 1 1.112.964l-.358.628H8.75a3.25 3.25 0 0 1 0 6.5H7v-1.5h1.75a1.75 1.75 0 0 0 1.75-1.75"/>`
    }, props));
$88bdbf9dcbbc0177$var$StatusWorkflowReturnedIcon.displayName = 'StatusWorkflowReturnedIcon';
var $88bdbf9dcbbc0177$var$_default = module.exports.default = $88bdbf9dcbbc0177$var$StatusWorkflowReturnedIcon;

});

parcelRegister("1WCRA", function(module, exports) {

let $16a95aaa6885cbab$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $16a95aaa6885cbab$var$load("4uvqP").then(()=>parcelRequire('3COP6'));

});

parcelRegister("Uu0Pb", function(module, exports) {
const $1c48b1994652ad1b$export$af156f0af92331bd = {
    BLUE: "var(--ds-background-accent-blue-subtle, #669DF1)",
    GREEN: "var(--ds-background-accent-green-subtle, #4BCE97)",
    YELLOW: "var(--ds-background-accent-yellow-subtle, #EED12B)",
    RED: "var(--ds-background-accent-red-subtle, #F87168)",
    PURPLE: "var(--ds-background-accent-purple-subtle, #C97CF4)",
    VERIFIED: "var(--ds-icon-accent-blue, #357DE8)"
};
const $1c48b1994652ad1b$export$c70dda424cd479ac = {
    BLUE: "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
    GREEN: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    YELLOW: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
    RED: "var(--ds-background-accent-red-subtlest, #FFECEB)",
    PURPLE: "var(--ds-background-accent-purple-subtlest, #F8EEFE)"
};
const $1c48b1994652ad1b$export$8380141af31d7b6a = {
    BLUE: "var(--ds-background-accent-blue-subtlest-hovered, #CFE1FD)",
    GREEN: "var(--ds-background-accent-green-subtlest-hovered, #BAF3DB)",
    YELLOW: "var(--ds-background-accent-yellow-subtlest-hovered, #F5E989)",
    RED: "var(--ds-background-accent-red-subtlest-hovered, #FFD5D2)",
    PURPLE: "var(--ds-background-accent-purple-subtlest-hovered, #EED7FC)"
};
const $1c48b1994652ad1b$export$e755b4518de49373 = {
    BLUE: 'blue',
    GREEN: 'green',
    YELLOW: 'yellow',
    RED: 'red',
    PURPLE: 'purple'
};
module.exports["PRIMARY_COLORS"] = $1c48b1994652ad1b$export$af156f0af92331bd;
module.exports["SECONDARY_COLORS"] = $1c48b1994652ad1b$export$c70dda424cd479ac;
module.exports["HOVER_COLORS"] = $1c48b1994652ad1b$export$8380141af31d7b6a;
module.exports["COLOR_NAMES"] = $1c48b1994652ad1b$export$e755b4518de49373;

});

parcelRegister("6a9Hv", function(module, exports) {

var $hWvFC = parcelRequire("hWvFC");


var $ghltV = parcelRequire("ghltV");

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $47cb339bef10f9e0$var$uniqBy(array, iteratee) {
    return array && array.length ? $ghltV(array, $hWvFC(iteratee, 2)) : [];
}
module.exports = $47cb339bef10f9e0$var$uniqBy;

});

parcelRegister("ghltV", function(module, exports) {

var $jcOUW = parcelRequire("jcOUW");


var $7LQYo = parcelRequire("7LQYo");


var $lkNSx = parcelRequire("lkNSx");


var $bcPN2 = parcelRequire("bcPN2");


var $eSSFf = parcelRequire("eSSFf");


var $fTWVK = parcelRequire("fTWVK");

/** Used as the size to enable large array optimizations. */ var $bd9ee5aa9be27a90$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $bd9ee5aa9be27a90$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $7LQYo, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $lkNSx;
    } else if (length >= $bd9ee5aa9be27a90$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $eSSFf(array);
        if (set) return $fTWVK(set);
        isCommon = false;
        includes = $bcPN2;
        seen = new $jcOUW;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $bd9ee5aa9be27a90$var$baseUniq;

});

parcelRegister("7LQYo", function(module, exports) {

var $gbGQI = parcelRequire("gbGQI");

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $5a8603892d8b8e7a$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $gbGQI(array, value, 0) > -1;
}
module.exports = $5a8603892d8b8e7a$var$arrayIncludes;

});

parcelRegister("gbGQI", function(module, exports) {

var $kQ62s = parcelRequire("kQ62s");


var $4iBhD = parcelRequire("4iBhD");


var $9vdTF = parcelRequire("9vdTF");

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $bc8ee968e98dba2a$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $9vdTF(array, value, fromIndex) : $kQ62s(array, $4iBhD, fromIndex);
}
module.exports = $bc8ee968e98dba2a$var$baseIndexOf;

});

parcelRegister("kQ62s", function(module, exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $f2bd591dc7dccf33$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = $f2bd591dc7dccf33$var$baseFindIndex;

});

parcelRegister("4iBhD", function(module, exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $3215c39807e7891a$var$baseIsNaN(value) {
    return value !== value;
}
module.exports = $3215c39807e7891a$var$baseIsNaN;

});

parcelRegister("9vdTF", function(module, exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $6eb1c9efc79a544d$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = $6eb1c9efc79a544d$var$strictIndexOf;

});

parcelRegister("lkNSx", function(module, exports) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $f882281822db2c99$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = $f882281822db2c99$var$arrayIncludesWith;

});

parcelRegister("eSSFf", function(module, exports) {

var $l57m2 = parcelRequire("l57m2");


var $hQNhB = parcelRequire("hQNhB");


var $fTWVK = parcelRequire("fTWVK");

/** Used as references for various `Number` constants. */ var $ad608304180e5c8a$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $ad608304180e5c8a$var$createSet = !($l57m2 && 1 / $fTWVK(new $l57m2([
    ,
    -0
]))[1] == $ad608304180e5c8a$var$INFINITY) ? $hQNhB : function(values) {
    return new $l57m2(values);
};
module.exports = $ad608304180e5c8a$var$createSet;

});

parcelRegister("jhwJP", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $8e78cdefc122a0a9$export$d1326a8d9df930b6 = (i18nBase, i18nLiveDocs)=>{
    const initializeData = (targetObj)=>{
        targetObj._data = (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? {
            ...i18nBase,
            ...i18nLiveDocs
        } : i18nBase;
        targetObj._initialized = true;
    };
    return new Proxy({}, {
        get: (targetObj, prop)=>{
            // Ensures retrieval of properties on i18n object use i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return targetObj._data[prop];
        },
        ownKeys: (targetObj)=>{
            // ensures `.keys` uses the i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return Reflect.ownKeys(targetObj._data);
        },
        has: (targetObj, prop)=>{
            // Ensures for...in uses the i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return prop in targetObj._data;
        },
        getOwnPropertyDescriptor: (targetObj, prop)=>{
            // Ensures i18n props are enumerable, required for ownKeys/etc to work
            if (!targetObj._initialized) initializeData(targetObj);
            const descriptor = Object.getOwnPropertyDescriptor(targetObj._data, prop);
            return descriptor ? {
                ...descriptor,
                enumerable: true
            } : undefined;
        }
    });
};
module.exports["mergeLiveDocI18n"] = $8e78cdefc122a0a9$export$d1326a8d9df930b6;

});

parcelRegister("8miSe", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ 
var $Uu0Pb = parcelRequire("Uu0Pb");

const $38122f14841a6560$export$b3a997d9e0eb41e = (color)=>{
    switch(color){
        case (0, $Uu0Pb.PRIMARY_COLORS).BLUE:
            return '#2684FF';
        case (0, $Uu0Pb.PRIMARY_COLORS).GREEN:
            return '#57D9A3';
        case (0, $Uu0Pb.PRIMARY_COLORS).YELLOW:
            return '#FFC400';
        case (0, $Uu0Pb.PRIMARY_COLORS).PURPLE:
            return '#8777D9';
        case (0, $Uu0Pb.PRIMARY_COLORS).RED:
            return '#FF7452';
        default:
            return '#2684FF';
    }
};
const $38122f14841a6560$export$979ed8c2392c1cb4 = (color)=>{
    const upperCaseColor = color?.toUpperCase(); // need toUpper since color we get from BE is lowercase
    switch(upperCaseColor){
        case '#2684FF':
            return (0, $Uu0Pb.PRIMARY_COLORS).BLUE;
        case '#57D9A3':
            return (0, $Uu0Pb.PRIMARY_COLORS).GREEN;
        case '#FFC400':
            return (0, $Uu0Pb.PRIMARY_COLORS).YELLOW;
        case '#8777D9':
            return (0, $Uu0Pb.PRIMARY_COLORS).PURPLE;
        case '#FF7452':
            return (0, $Uu0Pb.PRIMARY_COLORS).RED;
        default:
            return color;
    }
};
function $38122f14841a6560$export$4407ed99ceb09a2c(colorCode) {
    const upperCaseColorCode = colorCode?.toUpperCase();
    switch(upperCaseColorCode){
        case (0, $Uu0Pb.PRIMARY_COLORS).BLUE.toUpperCase():
            return (0, $Uu0Pb.COLOR_NAMES).BLUE;
        case (0, $Uu0Pb.PRIMARY_COLORS).GREEN.toUpperCase():
            return (0, $Uu0Pb.COLOR_NAMES).GREEN;
        case (0, $Uu0Pb.PRIMARY_COLORS).YELLOW.toUpperCase():
            return (0, $Uu0Pb.COLOR_NAMES).YELLOW;
        case (0, $Uu0Pb.PRIMARY_COLORS).RED.toUpperCase():
            return (0, $Uu0Pb.COLOR_NAMES).RED;
        case (0, $Uu0Pb.PRIMARY_COLORS).PURPLE.toUpperCase():
            return (0, $Uu0Pb.COLOR_NAMES).PURPLE;
        default:
            return (0, $Uu0Pb.COLOR_NAMES).BLUE;
    }
}
module.exports["tokenToHex"] = $38122f14841a6560$export$b3a997d9e0eb41e;
module.exports["hexToToken"] = $38122f14841a6560$export$979ed8c2392c1cb4;
module.exports["colorCodeToColorName"] = $38122f14841a6560$export$4407ed99ceb09a2c;

});

parcelRegister("4S6vT", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $Uu0Pb = parcelRequire("Uu0Pb");


var $8miSe = parcelRequire("8miSe");

const $87c020c14703301f$var$ContentStateColorSizes = {
    pageHistoryContentState: {
        ColorContainerStyles: (0, $ecnYn.xcss)({
            height: '10px',
            width: '10px',
            marginTop: 'space.0',
            marginBottom: 'space.0',
            marginLeft: 'space.050',
            marginRight: 'space.050'
        }),
        PlainContentStateColorStyles: (0, $ecnYn.xcss)({
            borderRadius: 'radius.full',
            width: '10px',
            height: '10px'
        }),
        scale: 'scale(0.625)',
        viewbox: '0 0 10px 10px'
    },
    rendererContentState: {
        ColorContainerStyles: (0, $ecnYn.xcss)({
            height: '12px',
            width: '12px',
            marginTop: 'space.0',
            marginBottom: 'space.0',
            marginRight: 'space.100',
            marginLeft: 'space.100'
        }),
        PlainContentStateColorStyles: (0, $ecnYn.xcss)({
            borderRadius: 'radius.xlarge',
            width: '12px',
            height: '12px'
        }),
        scale: 'scale(0.75)',
        viewbox: '0 0 12px 12px'
    },
    editorContentState: {
        ColorContainerStyles: (0, $ecnYn.xcss)({
            height: '16px',
            width: '16px',
            marginTop: 'space.0',
            marginBottom: 'space.0',
            marginLeft: 'space.400',
            marginRight: 'space.400'
        }),
        PlainContentStateColorStyles: (0, $ecnYn.xcss)({
            borderRadius: 'radius.full',
            width: '16px',
            height: '16px'
        }),
        scale: 'scale(1)',
        viewbox: '0 0 16px 16px'
    },
    contentStateButton: {
        ColorContainerStyles: (0, $ecnYn.xcss)({
            height: '12px',
            width: '12px',
            marginRight: 'space.050'
        }),
        PlainContentStateColorStyles: (0, $ecnYn.xcss)({
            borderRadius: 'radius.xlarge',
            width: '12px',
            height: '12px'
        }),
        scale: 'scale(0.75)',
        viewbox: '0 0 12px 12px'
    },
    spaceAdminContentState: {
        ColorContainerStyles: (0, $ecnYn.xcss)({
            maxHeight: '16px',
            maxWidth: '16px',
            marginRight: 'space.200'
        }),
        PlainContentStateColorStyles: (0, $ecnYn.xcss)({
            borderRadius: 'radius.full',
            width: '16px',
            height: '16px'
        }),
        scale: 'scale(1)',
        viewbox: '0 0 16px 16px'
    },
    restoreContentStatesModal: {
        ColorContainerStyles: (0, $ecnYn.xcss)({
            maxHeight: '16px',
            maxWidth: '16px'
        }),
        PlainContentStateColorStyles: (0, $ecnYn.xcss)({
            borderRadius: 'radius.full',
            width: '16px',
            height: '16px'
        }),
        scale: 'scale(1)',
        viewbox: '0 0 16px 16px'
    },
    subtleContentStateButton: {
        ColorContainerStyles: (0, $ecnYn.xcss)({
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '24px',
            width: '24px',
            marginRight: 'space.negative.025'
        }),
        PlainContentStateColorStyles: (0, $ecnYn.xcss)({
            borderRadius: 'radius.full',
            width: '10px',
            height: '10px'
        })
    },
    subtleRendererContentState: {
        ColorContainerStyles: (0, $ecnYn.xcss)({
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '24px',
            width: '24px'
        }),
        PlainContentStateColorStyles: (0, $ecnYn.xcss)({
            borderRadius: 'radius.full',
            width: '10px',
            height: '10px'
        })
    },
    contentStateInfoPopup: {
        ColorContainerStyles: (0, $ecnYn.xcss)({
            height: '16px',
            width: '16px',
            marginRight: 'space.100'
        }),
        PlainContentStateColorStyles: (0, $ecnYn.xcss)({
            borderRadius: 'radius.full',
            width: '16px',
            height: '16px'
        }),
        scale: 'scale(1)',
        viewbox: '0 0 16px 16px'
    }
};
// The SVG defaults to 16x16
// We need to scale to different sizes
const $87c020c14703301f$var$CheckCircleSvg = (color, dataTestId, scale, viewbox)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "100%",
        height: "100%",
        viewBox: viewbox,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            display: 'block'
        },
        "data-testid": dataTestId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        transform: scale
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.62505 0.990813C8.94443 -0.330271 7.05558 -0.330271 6.37496 0.990813C5.96598 1.78463 5.04334 2.1668 4.19284 1.89468C2.77742 1.4418 1.4418 2.77742 1.89468 4.19284C2.1668 5.04334 1.78463 5.96598 0.990813 6.37496C-0.330271 7.05558 -0.330271 8.94443 0.990813 9.62505C1.78463 10.034 2.1668 10.9567 1.89468 11.8072C1.4418 13.2226 2.77742 14.5582 4.19284 14.1053C5.04334 13.8332 5.96598 14.2154 6.37496 15.0092C7.05558 16.3303 8.94443 16.3303 9.62505 15.0092C10.034 14.2154 10.9567 13.8332 11.8072 14.1053C13.2226 14.5582 14.5582 13.2226 14.1053 11.8072C13.8332 10.9567 14.2154 10.034 15.0092 9.62505C16.3303 8.94443 16.3303 7.05558 15.0092 6.37496C14.2154 5.96598 13.8332 5.04334 14.1053 4.19284C14.5582 2.77742 13.2226 1.4418 11.8072 1.89468C10.9567 2.1668 10.034 1.78463 9.62505 0.990813ZM11.2176 5.5246L11.2951 5.59368C11.6175 5.91602 11.6405 6.42433 11.3642 6.77323L11.2951 6.85076L7.73956 10.4063C7.41722 10.7287 6.90894 10.7517 6.56003 10.4754L6.48251 10.4063L4.70473 8.62854C4.3576 8.28141 4.3576 7.71859 4.70473 7.37146C5.02707 7.04912 5.53535 7.02609 5.88425 7.30238L5.96178 7.37146L7.11117 8.52029L10.0381 5.59368C10.3604 5.27134 10.8687 5.24831 11.2176 5.5246Z",
        fill: color
    })));
const $87c020c14703301f$var$getDisplayedColor = (color, isWarning)=>{
    if (isWarning) // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    return Boolean(undefined) ? '#FF7452' : (0, $Uu0Pb.PRIMARY_COLORS).RED;
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    return Boolean(undefined) ? color : (0, $8miSe.hexToToken)(color);
};
const $87c020c14703301f$export$5ac2229016dfa3b6 = (t0)=>{
    const $ = (0, $frIzR.c)(15);
    const { color: color, restrictionLevel: t1, appearance: appearance, isWarning: t2, dataTestId: dataTestId } = t0;
    const restrictionLevel = t1 === undefined ? "NONE" : t1;
    const isWarning = t2 === undefined ? false : t2;
    const { ColorContainerStyles: ColorContainerStyles, viewbox: viewbox, PlainContentStateColorStyles: PlainContentStateColorStyles, scale: scale } = $87c020c14703301f$var$ContentStateColorSizes[appearance];
    let T0;
    let t3;
    let t4;
    if ($[0] !== ColorContainerStyles || $[1] !== PlainContentStateColorStyles || $[2] !== color || $[3] !== dataTestId || $[4] !== isWarning || $[5] !== restrictionLevel || $[6] !== scale || $[7] !== viewbox) {
        const displayedColor = $87c020c14703301f$var$getDisplayedColor(color ?? "#2684FF", isWarning);
        const isRestrictedState = restrictionLevel !== "NONE" && !isWarning;
        T0 = (0, $6f0Oj.default);
        t3 = ColorContainerStyles;
        t4 = isRestrictedState ? $87c020c14703301f$var$CheckCircleSvg(displayedColor, dataTestId, scale, viewbox) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            testId: dataTestId,
            xcss: PlainContentStateColorStyles,
            style: {
                backgroundColor: displayedColor,
                scale: scale
            }
        });
        $[0] = ColorContainerStyles;
        $[1] = PlainContentStateColorStyles;
        $[2] = color;
        $[3] = dataTestId;
        $[4] = isWarning;
        $[5] = restrictionLevel;
        $[6] = scale;
        $[7] = viewbox;
        $[8] = T0;
        $[9] = t3;
        $[10] = t4;
    } else {
        T0 = $[8];
        t3 = $[9];
        t4 = $[10];
    }
    let t5;
    if ($[11] !== T0 || $[12] !== t3 || $[13] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            xcss: t3
        }, t4);
        $[11] = T0;
        $[12] = t3;
        $[13] = t4;
        $[14] = t5;
    } else t5 = $[14];
    return t5;
};
module.exports["ContentStateColor"] = $87c020c14703301f$export$5ac2229016dfa3b6;

});

parcelRegister("iNJwL", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $d22b8e53da9786d0$export$795eadcf91da84fd = (0, $aXWIB.defineMessages)({
    maxLength: {
        id: "content-state.status.create.status.max.length",
        defaultMessage: "Max length of 20"
    },
    requiredErrorMessage: {
        id: "content-state.status.maker.error.message",
        defaultMessage: "Required"
    },
    emptyStatusFlagTitle: {
        id: "content-state.status.empty.status.flag.title",
        defaultMessage: "Your status can\u2019t be saved"
    },
    emptyStatusFlagDescription: {
        id: "content-state.status.empty.status.flag.description",
        defaultMessage: "Statuses must contain symbols or alphanumeric characters."
    },
    verifiedRestricted: {
        id: "content-state.verified-restricted",
        defaultMessage: "This content is verified. Only its owner or an admin can change its status."
    },
    verifiedRestrictedRbac: {
        id: "content-state.verified-restricted-rbac",
        defaultMessage: "This content is verified. Only its owner or someone with permission to manage all content in the space can change its status."
    },
    pageStatus: {
        id: "content-state.page-status",
        defaultMessage: "Status"
    },
    verifiedContentSpotlightTitle: {
        id: "content-state.verified-content.spotlight.title",
        defaultMessage: "Verified Content"
    },
    verifiedContentSpotlightAction: {
        id: "content-state.verified-content.spotlight.action",
        defaultMessage: "Set up automation"
    },
    newSpotlightTitle: {
        id: "content-state.automation-discovery.verified-content.title",
        defaultMessage: "Want to manage your verified pages?"
    },
    newSpotlightBody: {
        id: "content-state.automation-discovery.verified-content.body",
        defaultMessage: "Use Confluence automation to schedule reviews for verified content."
    },
    newSpotlightCta: {
        id: "content-state.automation-discovery.manual-trigger.cta.text",
        defaultMessage: "Build rule"
    },
    newSpotlightDismiss: {
        id: "content-state.automation-discovery.manual-trigger.dismiss",
        defaultMessage: "Done"
    }
});
module.exports["sharedi18n"] = $d22b8e53da9786d0$export$795eadcf91da84fd;

});


//# sourceMappingURL=StatusAndApprovalsConfig.d034af0c.js.map
